import gql from 'graphql-tag';

const MUTATION_BATCH_CREATE_ESIMS = gql`
  mutation batchCreateEsims($input: BatchCreateEsimsInput!) {
    batchCreateEsims(input: $input) {
      isSuccess
      message
      esims {
        id
      }
    }
  }
`;

export default MUTATION_BATCH_CREATE_ESIMS;
